<template>
  <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Purchased services by days</h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        Creation datetime range:
        <v-menu full-width offset-y :close-on-content-click="false"
                v-model="filterPurchasedServicesByDaysDateRangeMenuVisible" bottom>
          <v-btn color="primary" outline slot="activator">{{ purchasedServicesByDaysFilters.from }} &mdash; {{
            purchasedServicesByDaysFilters.to }}
          </v-btn>
          <v-card>
            <v-card-text>
              <v-daterange :options="purchasedServicesByDaysFilterOptions"
                           @input="handlePurchasedServicesByDaysDateRangeChange"
                           no-presets/>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-layout row wrap>
          <v-flex xs12>
            <bar-chart ref="purchasedServicesByDaysChart" :chartData="purchasedServicesByDaysDataSet" chart-id="stats-purchased-services-by-days"
                       :options="optionsBar" style="min-height: 400px"></bar-chart>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>

import api from '../../api'
import moment from 'moment'
import BarChart from '../Charts/Bar'
import _ from 'lodash'

export default {
  name: 'stats',
  components: {
    BarChart
  },
  props: {},
  data () {
    return {
      filterPurchasedServicesByDaysDateRangeMenuVisible: false,
      loading: false,
      purchasedServicesByDaysFilterOptions: {
        startDate: moment().subtract(1, 'mont  ').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        format: 'YYYY-MM-DD'
      },
      purchasedServicesByDaysFilters: {
        from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
      },
      purchasedServicesByDaysDataSet: null,
      optionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks:
                {
                  beginAtZero: true
                }
            }]
        }
      }
    }
  },
  async mounted () {
    let data = await api.getPurchasedServicesByDays(this.purchasedServicesByDaysFilters.from, this.purchasedServicesByDaysFilters.to)
    this.updatePurchasedServicesByDaysData(data)
  },
  methods: {
    handlePurchasedServicesByDaysDateRangeChange: _.debounce(async function (range) {
      this.purchasedServicesByDaysFilters.from = range[0]
      this.purchasedServicesByDaysFilters.to = range[1]
      let info = await api.getPurchasedServicesByDays(this.purchasedServicesByDaysFilters.from, this.purchasedServicesByDaysFilters.to)

      this.updatePurchasedServicesByDaysData(info)
    }, 500),
    updatePurchasedServicesByDaysData (info) {
      let dates = []
      let sum = []

      let data = info.data
      for (let date in data) {
        if (!data.hasOwnProperty(date)) {
          continue
        }

        dates.push(date)
        sum.push(data[date])
      }

      this.$set(this, 'purchasedServicesByDaysDataSet', {
        labels: dates,
        datasets: [
          {
            label: 'Amount',
            backgroundColor: '#29B6F6',
            data: sum
          }
        ]
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Stats.vue